import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { SaveSkipFooter } from 'widgets/HsptlzForm/ui';

import { useCaregiverFormContext } from '../model';

import { CaregiverForm } from './CaregiverForm';
import Field from './Field';
import { Title } from './Title';
import './caregiverForm.css';

export const CaregiverFormContainer = () => {
  const { contentCode } = useParams();
  const { addressData, invalidFields, setInvalidFields, accompaniment, setAddressData } = useCaregiverFormContext();
  const caregiverData = useBoundStore((state) => state.hsptlzForm.caregiverData);
  const setCaregiverData = useBoundStore((state) => state.hsptlzForm.setCaregiverData);
  const firstSubmitForm = useBoundStore((state) => state.hsptlzForm.firstSubmitForm);
  const setFirstSubmitForm = useBoundStore((state) => state.hsptlzForm.setFirstSubmitForm);
  const processHsptlzFormData = useBoundStore((state) => state.hsptlzForm.processFormData);
  const { caregiverRequired, caregiverMaxContacts } = processHsptlzFormData[contentCode];
  const navigate = useNavigate();
  const [relationship, setRelationship] = useState('');
  const nameInputRef = useRef(null);
  const birthInputRef = useRef(null);
  const sexInputRef = useRef(null);
  const phoneInputRefs = useRef([]);
  const phoneInputDataRef = useRef(null);
  const relationshipSelectRef = useRef(null);

  const [isValid, setIsValid] = useState(false);

  const onBlurBirth = (e) => {
    if (e.target.value.length === 8) {
      const year = Number(e.target.value.slice(0, 4));
      const month = Number(e.target.value.slice(4, 6));
      const day = Number(e.target.value.slice(6, 8));
      const inputDate = new Date(year, month - 1, day);

      const isValidDate = inputDate.getMonth() === month - 1 && !isNaN(inputDate.getTime());
      const now = new Date();
      const minDate = new Date(now.getFullYear() - 125, 0, 1);
      if (!isValidDate || inputDate < minDate || inputDate > now) {
        setInvalidFields({ ...invalidFields, birth: true });
      } else {
        setInvalidFields({ ...invalidFields, birth: false });
      }
    } else {
      setInvalidFields({ ...invalidFields, birth: true });
    }
  };

  const checkValidFields = () => {
    return Object.values(invalidFields).every((target) => {
      if (Array.isArray(target)) {
        return target.every((value) => value !== undefined && !value);
      }
      return target !== undefined && !target;
    });
  };
  // 수정 좀 필요 할 듯!
  const handleSubmit = () => {
    if (!checkValidFields()) {
      setFirstSubmitForm(false);
      return;
    }
    setCaregiverData({
      ...caregiverData,
      caregiverRelationship: relationship,
      caregiverName: nameInputRef.current.value,
      caregiverBirthDate: birthInputRef.current.value,
      caregiverSex: sexInputRef.current.checked ? 'M' : 'F',
      caregiverPhoneNumberList: phoneInputDataRef.current?.split('|') || [phoneInputDataRef.current],
      caregiverPostNumber: addressData.postNo,
      caregiverAddress: addressData.bscAddr,
      caregiverDetailAddress: addressData.dtlAddr,
    });

    navigate(`/hsptlz/form/mobile-form/${contentCode}`);
  };
  useEffect(() => {
    const validPhone = phoneInputRefs.current.every((ref) => ref?.value !== '');
    const isValidData =
      relationship &&
      nameInputRef.current?.value &&
      birthInputRef.current?.value &&
      validPhone &&
      addressData.postNo &&
      addressData.bscAddr &&
      addressData.dtlAddr;

    const checkValid = !firstSubmitForm ? checkValidFields() : true;
    if (checkValid && isValidData) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [invalidFields, addressData, relationship, accompaniment, firstSubmitForm]);

  const onSelectRelationship = (relationship) => {
    setRelationship(relationship);
  };

  const onCloseRelationship = () => {
    if (relationshipSelectRef.current) {
      relationshipSelectRef.current.classList.remove('active');
    }
  };
  useEffect(() => {
    window.addEventListener('click', (e) => {
      if (relationshipSelectRef.current) {
        onCloseRelationship();
      }
    });
    return () => {
      window.removeEventListener('click', onCloseRelationship);
    };
  }, []);

  useEffect(() => {
    setInvalidFields({ birth: false, tel: [false] });
    setAddressData({ bscAddr: '', dtlAddr: '', postNo: '' });
    setFirstSubmitForm(true);
    setRelationship('');
  }, [accompaniment]);

  return (
    <CaregiverForm>
      <Title>
        <Title.Main />
        <Title.Sub />
      </Title>
      <Field>
        <div className='caregiver-info-wrap'>
          <div className='caregiver-info-form'>
            <Field.InfoField>
              <Field.Relationship
                relationship={relationship}
                setRelationship={setRelationship}
                onSelectRelationship={onSelectRelationship}
                ref={relationshipSelectRef}
              />
              <Field.Name nameInputRef={nameInputRef} />
              <Field.BirthAndGender birthInputRef={birthInputRef} sexInputRef={sexInputRef} onBlurBirth={onBlurBirth} />
            </Field.InfoField>
            <Field.TelContainer
              phoneInputDataRef={phoneInputDataRef}
              msgRcvTelMaxNum={caregiverMaxContacts}
              ref={phoneInputRefs}
            />
            <Field.AddressContainer />
          </div>
        </div>
      </Field>
      <SaveSkipFooter text={'저장 후 다음'} handleClick={handleSubmit} disabled={!isValid} isValid={isValid} />
    </CaregiverForm>
  );
};
